var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-video"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8 col-12"},[_c('div',{staticClass:"video-clip"},[_c('video',{staticClass:"w-100",staticStyle:{"height":"auto"},attrs:{"controls":""}},[_c('source',{attrs:{"src":"/especiales/factchecking-loreto/clips/clip_01.mp4","type":"video/mp4"}})])])])])])
}]

export { render, staticRenderFns }